import React, { useState } from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Box } from '@mui/system';
import { IMAGE_ALTERNATE_TEXT } from '../../shared/Strings';
import { FormControl, Typography } from '@mui/material';
import { Directions } from '@mui/icons-material';

const dropDownWrapper = {
  minWidth: 160,
  height: '40px',
  marginRight: '12px',
  display: 'flex',
  justifyContent: 'center',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  paddingRight: '10px',
  color: '#4B4B4B',
  borderRadius: '8px',
  backgroundColor: '#fff',
  flexDirections: 'row',
  boxShadow: '0px 2px 10px rgba(0,0,0,0.08)',
  marginTop: '8px',

  '& .MuiInput-root': {
    height: '100%',
    width: '100%',
  },
  '& .MuiSelect-root': {
    height: '100%',
  },
  '& .MuiInputBase-input': {
    padding: 0,
    display: 'flex',
    alignItems: 'center',
  },
  '.css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
    borderColor: 'white!important',
  },
  '.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon': {
    // position: 'relative',
  },
  '.css-ll2gwc': {
    position: 'inherit!important',
  },
  '.css-igs3ac': {
    border: 'none!important',
  },
};
const listTag = {
  // width: 160,
  flex: 1,
  height: 40,
  paddingLeft: '6px',
  paddingRight: '8px',
};
const selectRoot = {
  fontSize: '16px',
  height: '100%',
  boxSizing: 'border-box',
  paddingTop: 0,
  paddingBottom: 0,
};
const dropDownMenuList = {
  fontSize: '16px',
  paddingLeft: 0,
  paddingRight: 0,
};
const labelWrapper = {
  display: 'flex',
  alignItems: 'center',
  maxHeight: '40px',
  paddingLeft: '12px',

  flexDirection: 'row',

  fontWeight: 600,
  minWidth: '64px',
};
//img: { width: 8, height: 8, marginRight: 8 },
//const muiIcon = { width: 12, height: 12, marginRight: 4 };
const label = {
  height: '24px',
  padding: '0px',
  paddingLeft: '5px',
  display: 'flex',
  alignItems: 'center',
  margin: 0,
};

const img = {
  width: '12px',
  height: '12px',
};
const filterTypes = {
  lineHeight: '0px',
  paddingLeft: '8px',
  minWidth: 'max-content',
  fontSize: '14px',
  fontWeight: 600,
  color: '#737373',
};
const FilterDropDown = ({
  changeHandler,
  rootContainerStyle,
  filterType,
  ...props
}) => {
  const [value, setValue] = useState(props.value);
  const onChange = val => {
    setValue(val);
    changeHandler(val);
  };

  return (
    <FormControl sx={dropDownWrapper}>
      {props.inputLabel && (
        <InputLabel id="inputLabel">{props.inputLabel}</InputLabel>
      )}

      <Box style={{ display: 'flex', alignItems: 'center' }}>
        <Typography sx={filterTypes}>{filterType || ''}</Typography>

        <Select
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'center',
            },
            MenuListProps: {
              disablePadding: true,
            },
            getContentAnchorEl: null,
          }}
          labelId="demo-simple-select-label"
          sx={{ border: 'none!important' }}
          id="demo-simple-select"
          defaultValue="10"
          disableUnderline
          value={value}
          onChange={onChange}
          {...props}>
          {props.options?.map((option, index) => {
            return (
              <MenuItem key={index} value={option.value} sx={listTag}>
                <Box sx={labelWrapper}>
                  {option.icon && (
                    <Box sx={{ mr: '8px' }}>
                      <img
                        src={option.icon}
                        alt={IMAGE_ALTERNATE_TEXT.ICON}
                        sx={img}
                      />
                    </Box>
                  )}
                  <Box sx={label}>{option.label || option.value}</Box>
                </Box>
              </MenuItem>
            );
          })}
        </Select>
      </Box>
    </FormControl>
  );
};

export default FilterDropDown;
